import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [persons] = useState(['Yeon', 'Spouse']);
  const [issuers, setIssuers] = useState([]);
  const [cardsData, setCardsData] = useState([]);
  const [airlines, setAirlines] = useState([]);
  const [hotels, setHotels] = useState([]);

  const [cards, setCards] = useState([]);
  const [airlinesState, setAirlinesState] = useState([]);
  const [hotelsState, setHotelsState] = useState([]);

  const [showCards, setShowCards] = useState(true);
  const [showAirlines, setShowAirlines] = useState(true);
  const [showHotels, setShowHotels] = useState(true);

  useEffect(() => {
    fetch('/api/issuers')
      .then(res => res.json())
      .then(data => setIssuers(data));

    fetch('/api/cards')
      .then(res => res.json())
      .then(data => setCardsData(data));

    fetch('/api/airlines')
      .then(res => res.json())
      .then(data => setAirlines(data));

    fetch('/api/hotels')
      .then(res => res.json())
      .then(data => setHotels(data));
  }, []);

  const addItem = (stateSetter, defaultItem) => {
    stateSetter(prev => [...prev, defaultItem]);
  };

  const updateItem = (stateSetter, index, field, value, convert = false) => {
    stateSetter(prev => {
      const copy = [...prev];
      copy[index][field] = convert ? Number(value) : value;
      return copy;
    });
  };

  const calcTotal = (arr, pointsField = 'points', accrualField = 'accrual') =>
    arr.reduce((sum, c) => sum + (c[pointsField] || 0) * 0.02, 0);

  return (
    <div style={{ maxWidth: '1100px', margin: '2rem auto', fontFamily: 'Arial' }}>
      <h2>AirConxt Points Dashboard</h2>

      {/* Credit Cards Section */}
      <h4>Credit Cards <button onClick={() => setShowCards(!showCards)}> {showCards ? 'Collapse' : 'Expand'} </button></h4>
      {showCards && (
        <div style={sectionStyle}>
          {cards.map((card, i) => (
            <div key={i} style={rowStyle}>
              <select value={card.person} onChange={e => updateItem(setCards, i, 'person', e.target.value)}>
                {persons.map(p => <option key={p}>{p}</option>)}
              </select>
              <select value={card.issuer_id} onChange={e => updateItem(setCards, i, 'issuer_id', e.target.value)}>
                {issuers.map(iss => <option key={iss.id} value={iss.id}>{iss.name}</option>)}
              </select>
              <select value={card.card_name} onChange={e => updateItem(setCards, i, 'card_name', e.target.value)}>
                {cardsData.map(c => <option key={c.id}>{c.card_name}</option>)}
              </select>
              <input placeholder="Last 4" value={card.last4 || ''} onChange={e => updateItem(setCards, i, 'last4', e.target.value)} />
              <input placeholder="Points" type="number" value={card.points || ''} onChange={e => updateItem(setCards, i, 'points', e.target.value, true)} />
              <input placeholder="Monthly Accrual" type="number" value={card.accrual || ''} onChange={e => updateItem(setCards, i, 'accrual', e.target.value, true)} />
              <input placeholder="Username" value={card.username || ''} onChange={e => updateItem(setCards, i, 'username', e.target.value)} />
            </div>
          ))}
          <button onClick={() => addItem(setCards, { person: 'Yeon', issuer_id: '', card_name: '', last4: '', points: 0, accrual: 0, username: '' })}>
            + Add Another
          </button>
          <p style={totalStyle}>💳 Total Card Value: ${calcTotal(cards).toFixed(2)}</p>
        </div>
      )}

      {/* Airlines Section */}
      <h4>Airline Programs <button onClick={() => setShowAirlines(!showAirlines)}> {showAirlines ? 'Collapse' : 'Expand'} </button></h4>
      {showAirlines && (
        <div style={sectionStyle}>
          {airlinesState.map((a, i) => (
            <div key={i} style={rowStyle}>
              <select value={a.person} onChange={e => updateItem(setAirlinesState, i, 'person', e.target.value)}>
                {persons.map(p => <option key={p}>{p}</option>)}
              </select>
              <select value={a.program_name} onChange={e => updateItem(setAirlinesState, i, 'program_name', e.target.value)}>
                {airlines.map(a => <option key={a.id}>{a.program_name}</option>)}
              </select>
              <input placeholder="Points" type="number" value={a.points || ''} onChange={e => updateItem(setAirlinesState, i, 'points', e.target.value, true)} />
              <input placeholder="Yearly Accrual" type="number" value={a.accrual || ''} onChange={e => updateItem(setAirlinesState, i, 'accrual', e.target.value, true)} />
              <input placeholder="Username" value={a.username || ''} onChange={e => updateItem(setAirlinesState, i, 'username', e.target.value)} />
              <input placeholder="Password" type="password" value={a.password || ''} onChange={e => updateItem(setAirlinesState, i, 'password', e.target.value)} />
            </div>
          ))}
          <button onClick={() => addItem(setAirlinesState, { person: 'Yeon', program_name: '', points: 0, accrual: 0, username: '', password: '' })}>
            + Add Another
          </button>
          <p style={totalStyle}>✈️ Total Airline Value: ${calcTotal(airlinesState).toFixed(2)}</p>
        </div>
      )}

      {/* Hotels Section */}
      <h4>Hotel Memberships <button onClick={() => setShowHotels(!showHotels)}> {showHotels ? 'Collapse' : 'Expand'} </button></h4>
      {showHotels && (
        <div style={sectionStyle}>
          {hotelsState.map((h, i) => (
            <div key={i} style={rowStyle}>
              <select value={h.person} onChange={e => updateItem(setHotelsState, i, 'person', e.target.value)}>
                {persons.map(p => <option key={p}>{p}</option>)}
              </select>
              <select value={h.program_name} onChange={e => updateItem(setHotelsState, i, 'program_name', e.target.value)}>
                {hotels.map(h => <option key={h.id}>{h.program_name}</option>)}
              </select>
              <input placeholder="Points" type="number" value={h.points || ''} onChange={e => updateItem(setHotelsState, i, 'points', e.target.value, true)} />
              <input placeholder="Yearly Accrual" type="number" value={h.accrual || ''} onChange={e => updateItem(setHotelsState, i, 'accrual', e.target.value, true)} />
              <input placeholder="Username" value={h.username || ''} onChange={e => updateItem(setHotelsState, i, 'username', e.target.value)} />
              <input placeholder="Password" type="password" value={h.password || ''} onChange={e => updateItem(setHotelsState, i, 'password', e.target.value)} />
            </div>
          ))}
          <button onClick={() => addItem(setHotelsState, { person: 'Yeon', program_name: '', points: 0, accrual: 0, username: '', password: '' })}>
            + Add Another
          </button>
          <p style={totalStyle}>🏨 Total Hotel Value: ${calcTotal(hotelsState).toFixed(2)}</p>
        </div>
      )}

      <h3 style={totalStyle}>🏅 Total Portfolio Value: ${(calcTotal(cards) + calcTotal(airlinesState) + calcTotal(hotelsState)).toFixed(2)}</h3>
    </div>
  );
}

const sectionStyle = {
  border: '1px solid #ccc',
  borderRadius: '6px',
  padding: '1rem',
  marginBottom: '1.5rem',
  background: '#fdfdfd',
};

const rowStyle = {
  display: 'flex',
  gap: '0.5rem',
  marginBottom: '0.5rem',
  flexWrap: 'wrap',
};

const totalStyle = {
  fontWeight: 'bold',
  marginTop: '0.5rem',
};

export default App;
